import script from "./SocialAssetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialAssetPage.vue?vue&type=script&setup=true&lang=js"

import "./SocialAssetPage.vue?vue&type=style&index=0&id=582a545c&lang=scss"

const __exports__ = script;

export default __exports__